
import React, {Component} from 'react'
import './Emp.css'
import {categories} from './Data'

class Emp extends Component
{
	display_categories = _ =>
	{
		let items = categories.map((item, index) =>
		{
			return (
				<div className = 'col-md-2 text-center' key = {Math.random()}>
					<div className = {`i item${index} rounded mb-lg-0 mb-5`}>
						<img className = 'img mb-4' src = {item.img.default} alt = {item.name} />
						<h5 className = 'sub-title text-capitalize'>{item.name}</h5>
					</div>
				</div>
			)
		})
		return items
	}

	render()
	{
		return (
			<div className = 'materials py-2 my-5' id = 'materials'>
				<div className = 'container'>
					<div className = 'title py-5 text-left'>
						<h4 className = 'sub-title text-capitalize'>Nuestros <span>clientes</span></h4>
					</div>
					<div className = 'row justify-content-lg-between justify-content-center'>
						{this.display_categories()}
					</div>
				</div>
			</div>
		)
	}
}

export default Emp